package com.ervasstudio.tracoemovimento.components.custumcomponents.layout

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.SideEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.ervasstudio.tracoemovimento.util.Res
import com.huanshankeji.compose.html.material3.MdMenu
import com.huanshankeji.compose.html.material3.MdMenuItem
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import kotlinx.browser.document
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.px
import org.w3c.dom.Node
import org.w3c.dom.events.Event

@Composable
fun MdMenuDropdown(
    nome: String? = "Fromel",
    estado: String = "Logado",
    onPerfilClick: () -> Unit = {},
    onPagamentosClick: () -> Unit = {},
    onAjudaClick: () -> Unit = {},
    onLogoutClick: () -> Unit = {},
    isMobile: Boolean ,
) {
    var menuOpen by remember { mutableStateOf(false) }
    val anchorId = "menu-perfil-anchor"
    val menuId = "menu-perfil-dropdown"

    Box(modifier = Modifier.position(Position.Relative)) {
        MenuPerfil(
            anchorId = anchorId,
            nome = nome,
            estado = estado,
            onClick = {
                menuOpen = !menuOpen
            },
            isMobile = isMobile // já fecha se estiver aberto — só precisa parar de "brigar" com o listener nativo,
        )

        MdMenu(
            anchor = anchorId,
            open = menuOpen, // mantemos, mas não confiamos só nisto — ver SideEffect abaixo
            quick = true,
            attrs = {
                id(menuId)
                ref { element ->
                    element.asDynamic().defaultFocus = "none"
                    onDispose { }
                }
            },
            content = {
                MdMenuItem(attrs = { onClick { menuOpen = false; onPerfilClick() } }) {
                    Row(
                        modifier = Modifier.gap(4.px),
                        horizontalArrangement = Arrangement.SpaceBetween,
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        if (isMobile) nome?.let { SpanText(it) } else SpanText("Perfil")
                        Image(
                            src = Res.Image.usermenu,
                            alt = "UserMenu",
                            modifier = Modifier.width(if (isMobile) 12.px else 28.px)
                        )
                    }

                }
                MdMenuItem(attrs = { onClick { menuOpen = false; onPagamentosClick() } }) {

                    Row(
                        modifier = Modifier.gap(if (isMobile) 2.px else 4.px),
                        horizontalArrangement = Arrangement.SpaceBetween,
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        SpanText("Pagamentos")
                        Image(
                            src = Res.Image.pagamentos,
                            alt = "Pagamentos",
                            modifier = Modifier.width(if (isMobile) 12.px else 28.px)
                        )
                    }



                }
                MdMenuItem(attrs = { onClick { menuOpen = false; onAjudaClick() } }) {
                    Row(
                        modifier = Modifier.gap(if (isMobile) 2.px else 4.px),
                        horizontalArrangement = Arrangement.SpaceBetween,
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        SpanText("Ajuda")
                        Image(
                            src = Res.Image.help,
                            alt = "Ajuda",
                            modifier = Modifier.width(if (isMobile) 12.px else 28.px)
                        )
                    }

                     }
                MdMenuItem(attrs = { onClick { menuOpen = false; onLogoutClick() } }) {
                    Row(
                        modifier = Modifier.gap(if (isMobile) 2.px else 4.px),
                        horizontalArrangement = Arrangement.SpaceBetween,
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        SpanText("Logout")
                        Image(
                            src = Res.Image.logout,
                            alt = "Logout",
                            modifier = Modifier.width(if (isMobile) 12.px else 28.px)
                        )
                    }
                }
            }
        )
    }

    // Força o estado real do web component a cada recomposição — corrige tanto o
    // "inicia aberto" (agora sincroniza já no mount, com menuOpen = false)
    // quanto o fecho, que deixa de depender do timing interno do próprio componente.
    SideEffect {
        val el = document.getElementById(menuId)?.asDynamic()
        if (el != null && el.open != menuOpen) {
            el.open = menuOpen
        }
    }

    // Deteção de clique fora — só fica ativa depois do menu abrir de facto
    DisposableEffect(menuOpen) {
        if (menuOpen) {
            val handler: (Event) -> Unit = { event ->
                val target = event.target as? Node
                val anchorEl = document.getElementById(anchorId)
                val menuEl = document.getElementById(menuId)
                val clicouFora = target != null &&
                        anchorEl?.contains(target) != true &&
                        menuEl?.contains(target) != true
                if (clicouFora) menuOpen = false
            }
            document.addEventListener("click", handler)
            onDispose { document.removeEventListener("click", handler) }
        } else {
            onDispose { }
        }
    }
}